import styled from 'styled-components';

import mixin from '../../../../_foundations/Mixin';

const ActionMenuTitleComponent = styled.div`
  ${mixin.text({ size: 100, strong: true })};
  height: 2.5rem;
  padding: 0.5rem;
  width: 100%;
  color: var(--neutral-600);
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default ActionMenuTitleComponent;
